export default "__VITE_ASSET__Cb51eJmm__"